import {inject, Injectable} from '@angular/core';
import {Observable} from 'rxjs';
import {TextItem} from '../api/models/text-item';
import {SearchStore} from '../stores/search.store';
import {SearchState} from '../modules/akita-mimic/models/store-states/search-state.model';
import {QueryService} from '../modules/akita-mimic/services/query.service';

@Injectable({ providedIn: 'root' })
export class SearchQuery extends QueryService<SearchState> {
    public listSelectedTextItems$: Observable<Array<TextItem>> = this.select('listSelectedTextItems');

    public constructor() {
        const store = inject(SearchStore);
        super(store);
    }
}
